package com.milta.core.cache

import kotlinx.browser.localStorage

/** Kotlin/JS implementation of [LocalCacheStore] — browser `localStorage` via `kotlinx.browser`. */
class JsLocalCacheStore : LocalCacheStore {
    override fun putString(key: String, value: String) { localStorage.setItem(key, value) }
    override fun getString(key: String): String? = localStorage.getItem(key)
    override fun remove(key: String) { localStorage.removeItem(key) }
}
